module.exports = __webpack_public_path__ + "img/tose.328e4aca.jpg";